module.exports = __webpack_public_path__ + "media/images/hello-16bba1aeaaba9b4ea8691bd47566b777.png";